module.exports = __webpack_public_path__ + "static/img/3_1_3_1.1b29a57e.jpg";